import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import "./goldify.css";
import "./goldify.scss";
import Products from "../products/Products";
import axiosInstance from "../../utils/axiosInstance";

import Loader from "../../components/Loader";
import BuySell from "../../components/BuySell";
import BuySellMmtc from "../../components/BuySellMmtc";

import { getGoldApi } from "../../redux/features/goldSlice";
import { mmtcGoldApi } from "../../redux/features/mmtc/goldSlice";
import { portfolioApi } from "../../redux/features/portfolio/portfolioSlice";
import CustomButton from "../../components/CustomButton";
import CustomGoldAndSilverSip from "../customGoldAndSilverSip/CustomGoldAndSilverSip";

const switchBtns = [
  { label: "Buy", value: "buy", link: "/dashboard/gold/buy" },
  { label: "Sell", value: "sell", link: "/dashboard/gold/sell" },
  { label: "Delivery", value: "delivery", link: "/dashboard/gold/delivery" },
];

const Goldify = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { isAmount, amount: passedAmount } = location.state || {};

  const pathname = location.pathname;
  const sections = ["buy", "sell", "delivery", "sip"];

  const section = sections.find((section) => pathname.includes(section)) || "";

  const [activeButton, setActiveButton] = useState("Augmont");
  const [value, setValue] = useState("buy");

  useEffect(() => {
    dispatch(portfolioApi());
  }, [dispatch]);

  useEffect(() => {
    if (activeButton === "Augmont") {
      dispatch(getGoldApi());
    } else {
      const payload = {
        currencyPair: "XAU/INR",
        type: value === "buy" ? "BUY" : "SELL",
      };
      dispatch(mmtcGoldApi(payload));
    }
  }, [dispatch, activeButton, value]);

  const callQuantityAPI = async (
    rupeeValue,
    gramValue,
    status,
    transactionType
  ) => {
    try {
      const URL =
        transactionType === "goldBuy"
          ? "/augmont/get-quote-buy"
          : "/augmont/get-quote-sell";

      const pageLink =
        transactionType === "goldBuy"
          ? "/dashboard/gold-buy-summary"
          : "/dashboard/gold-sell-summary";

      const requestBody = {
        metalType: "gold",
        ...(status.isAmount ? { amount: rupeeValue } : { quantity: gramValue }),
      };

      const response = await axiosInstance.post(URL, requestBody);

      navigate(pageLink, {
        state: {
          key: "augmont",
          data: response.data,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error connecting to API", error);
    }
  };

  const mmtcBuyApi = async (
    rupeeValue,
    gramValue,
    isRupeeSelected,
    transactionType
  ) => {
    try {
      const pageLink =
        transactionType === "goldBuy"
          ? "/dashboard/gold-buy-summary"
          : "/dashboard/gold-sell-summary";

      const payload = {
        currencyPair: "XAU/INR",
        value: isRupeeSelected ? rupeeValue : gramValue,
        type: isRupeeSelected ? "A" : "Q",
      };

      const URL = `/customTrade/${
        transactionType === "goldSell" || transactionType === "silverSell"
          ? "sell"
          : "buy"
      }`;

      const response = await axiosInstance.post(URL, payload);

      if (!response.data.error) {
        navigate(pageLink, {
          state: {
            key: "mmtc",
            data: response.data,
          },
        });
      } else {
        toast.error("ERROR IN MMTC BUY API");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const {
    data: portApiRes,
    errors,
    loading: portApiLoading,
  } = useSelector((state) => state.portfolioSlice);

  const {
    data: augmontData,
    error: augmontError,
    loading: augPriceApiLoading,
  } = useSelector((state) => state.goldSlice);

  const {
    data,
    error,
    loading: mmtcPriceApiLoading,
  } = useSelector((state) => state.mmtcGoldSlice);

  // framer motion==================

  const variants = {
    initial: (direction) => ({
      x: direction === "left" ? "-20%" : "20%", // Reduced distance from 100% to 40%
      opacity: 0,
    }),
    animate: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.4, ease: "easeInOut" }, // Slowed down from 0.4s to 0.6s
    },
    exit: (direction) => ({
      x: direction === "left" ? "20%" : "-20%", // Reduced exit distance
      opacity: 0,
      transition: { duration: 0.4, ease: "easeInOut" },
    }),
  };

  const getDirection = (prev, current) => {
    const order = ["buy", "sell", "delivery"];
    return order.indexOf(current) > order.indexOf(prev) ? "right" : "left";
  };

  const [prevValue, setPrevValue] = React.useState(value);

  useEffect(() => {
    setPrevValue(value);
  }, [value]);

  useEffect(() => {
    if (activeButton === "MMTC" && value === "delivery") {
      setValue("buy"); // Switch to "Buy" if on "Delivery"
    }
  }, [activeButton, value]);

  const [activeTab, setActiveTab] = useState("oneTime");

  return (
    <main>
      <div style={{ position: "relative" }}>
        <div className="switch_btn_container">
          {/* BUY & SELL==============  */}
          <div className="toggle-container" style={{ alignSelf: "start" }}>
            <div className="toggle-wrapper">
              <div
                className="slider"
                style={{
                  left: location.pathname.includes("sip")
                    ? "0%"
                    : location.pathname.includes("buy")
                    ? "0%"
                    : location.pathname.includes("sell")
                    ? "33.33%"
                    : location.pathname.includes("delivery")
                    ? "66.66%"
                    : "0%",
                  width: location.pathname.includes("sip")
                    ? "33.33%"
                    : "33.33%",
                }}
              ></div>
              {[
                {
                  label: "Buy",
                  value: "buy",
                  link: "/dashboard/gold/buy",
                },
                {
                  label: "Sell",
                  value: "sell",
                  link: "/dashboard/gold/sell",
                },
                {
                  label: "Delivery",
                  value: "delivery",
                  link: "/dashboard/gold/delivery",
                },
              ].map((btn) => (
                <button
                  key={btn.value}
                  className={`toggle-button ${
                    location.pathname.includes(btn.value) ||
                    (location.pathname.includes("sip") && btn.value === "buy")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setValue(btn.value);
                    navigate(btn.link);
                  }}
                  style={{ flex: 1 }}
                >
                  {btn.label}
                </button>
              ))}
            </div>
          </div>
          {/* SIP=============  */}
          {!location.pathname.includes("sell") &&
            !location.pathname.includes("delivery") && (
              <div className="toggle-container sip-tab-container">
                <div className="toggle-wrapper">
                  <div
                    className="slider"
                    style={{
                      // left: activeTab === "oneTime" ? "0%" : "50%",
                      left: location.pathname.includes("sip") ? "50%" : "0%",
                      width: `${100 / 2}%`,
                    }}
                  ></div>
                  {[
                    {
                      label: "One Time",
                      value: "oneTime",
                      link: "/dashboard/gold/buy",
                      active: !location.pathname.includes("sip"),
                    },
                    {
                      label: "Monthly SIP",
                      value: "monthlySip",
                      link: "/dashboard/gold/sip",
                      active: location.pathname.includes("sip"),
                    },
                  ].map((btn) => (
                    <button
                      key={btn.value}
                      className={`toggle-button ${btn.active ? "active" : ""}`}
                      onClick={() => {
                        if (!btn.disabled) {
                          navigate(btn.link);
                          setActiveTab(btn.value);
                        }
                      }}
                    >
                      {btn.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              // marginBottom: "1.5rem",
            }}
          >
            <div className="test_btn_box">
              <button
                className={`test_btn_provider ${
                  activeButton === "Augmont"
                    ? "test_btn_active"
                    : "test_btn_inactive"
                }`}
                onClick={() => setActiveButton("Augmont")}
              >
                Augmont
              </button>
              <div style={{ border: "1px solid black" }}></div>
              <button
                className={`test_btn_provider ${
                  activeButton === "MMTC"
                    ? "test_btn_active"
                    : "test_btn_inactive"
                }`}
                onClick={() => setActiveButton("MMTC")}
              >
                MMTC
              </button>
            </div>
          </div> */}
        </div>

        {/* {activeTab !== "oneTime" ? ( */}
        {section === "sip" ? (
          <CustomGoldAndSilverSip />
        ) : (
          <motion.div
            key={section}
            custom={getDirection(prevValue, section)}
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ width: "100%" }}
          >
            {!portApiLoading && (augmontData || data) ? (
              section === "buy" ? (
                activeButton === "Augmont" ? (
                  <BuySell
                    metalType="GOLD"
                    transactionType="goldBuy"
                    goldApiData={augmontData}
                    portfolioApiData={portApiRes}
                    callQuantityAPI={callQuantityAPI}
                    isAmount={isAmount}
                    userAmt={passedAmount}
                  />
                ) : (
                  <BuySellMmtc
                    livePrice={data}
                    metalType="GOLD"
                    transactionType="goldBuy"
                    portfolioApiData={portApiRes}
                    mmtcBuyApi={mmtcBuyApi}
                    userAmt={passedAmount}
                  />
                )
              ) : section === "sell" ? (
                activeButton === "Augmont" ? (
                  <BuySell
                    metalType="GOLD"
                    transactionType="goldSell"
                    goldApiData={augmontData}
                    portfolioApiData={portApiRes}
                    callQuantityAPI={callQuantityAPI}
                  />
                ) : (
                  <BuySellMmtc
                    livePrice={data}
                    metalType="GOLD"
                    transactionType="goldSell"
                    portfolioApiData={portApiRes}
                    mmtcBuyApi={mmtcBuyApi}
                    userAmt={passedAmount}
                  />
                )
              ) : section === "delivery" ? (
                <Products />
              ) : (
                <div>Something went wrong</div>
              )
            ) : (
              <div style={{ height: "50vh" }}>
                <Loader />
              </div>
            )}
          </motion.div>
        )}
      </div>
    </main>
  );
};

export default Goldify;
